import React, { useEffect, useState } from "react";
import { Select, Table } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { VaporDatePicker } from "../../vapor";
import { DATE_FORMAT_FOR_API, DATE_FORMAT_FOR_DISPLAY } from "../../../constants/constants";
import moment from "moment";
import "./style.scss";
import EmptyState from "../../vapor/emptyState";
import DrawerOperationsList from "../drawerOperationsList";
import { FormattedMessage, useIntl } from "react-intl";

const Option = Select.Option;

const AccountingYearsList = ({accountingYearsList}) => {
  const intl = useIntl();
  const [drawerAccountingPeriodId, setDrawerAccountingPeriodId] = useState(null);
  const [filtersTable, setFiltersTable] = useState(null);
  const [filteredList, setFilteredList] = useState([]);
  const [selectedSequenceNumber, setSelectedSequenceNumber] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY", "DD-MM-YYYY", "DD-MM-YY", "DDMMYYYY", "DDMMYY"];

  const minYear = Math.min(...accountingYearsList.map(item => item.sequenceNumber));
  const maxYear = Math.max(...accountingYearsList.map(item => item.sequenceNumber));

  useEffect(() => {    
    setFilteredList(accountingYearsList);
  }, [accountingYearsList]);

  useEffect(() => {
    const filterNew = accountingYearsList.filter(function(item) {
      for (let key in filtersTable) {                
        if (filtersTable[key] && (item[key] === undefined || !(item[key].toString()).includes(filtersTable[key])))
          return false;
      }
      return true;
    });

    setFilteredList(filterNew);
      
  }, [filtersTable]);
  
  const handleChange = (filterKey, value) => {
    setFiltersTable({
      ...filtersTable,
      [filterKey]: value
    });
  };
  
  const columns = [
    {
      title: intl.formatMessage({ id: "accountingYear.table.header.year"}),
      dataIndex: "sequenceNumber",
      render: value => (value === "initial" ?
        <Select
          getPopupContainer={(trigger) => trigger.parentNode}
          className="input-search transparent noBorder"
          allowClear={true}
          placeholder={<FormattedMessage id="accountingYear.table.select" />}
          onChange={(val) => handleChange("sequenceNumber",val)}
        >
          <Option value={null}><FormattedMessage id="accountingYear.table.all" /></Option>
          {
            /** Gli anni per la select li carico dal minimo al massimo presenti in lista */
            Array.apply(null, {length: maxYear + 1}).map(Number.call, Number).slice(minYear).map(el => {
              return <Option key={el} value={el}>{el}</Option>;
            })            
          }          
        </Select>       
        : value),
      sorter: (a, b) => { return a.sequenceNumber ==="initial" || b.sequenceNumber ==="initial" ? 0 : a.sequenceNumber.localeCompare(b.sequenceNumber);}
    },
    {
      title: intl.formatMessage({ id: "accountingYear.table.header.startDate" }),
      dataIndex: "startDate",
      render: value => (value === "initial" ? <>
        <VaporDatePicker
          format={dateFormatList}
          getPopupContainer={(trigger) => trigger.parentNode}
          placeholder={intl.formatMessage({ id: "accountingYear.table.findDate"})}
          allowClear={true}
          className="date-search"
          onChange={(e) => e ? handleChange("startDate", moment(e).format(DATE_FORMAT_FOR_API)) : handleChange("startDate", null)}
        /></> : <span>{moment(value).format(DATE_FORMAT_FOR_DISPLAY)}</span>),
      sorter: (a, b) => { return a.startDate ==="initial" || b.startDate ==="initial" ? 0 : ((a.startDate > b.startDate) - (a.startDate < b.startDate));}
    },
    {
      title: intl.formatMessage({ id: "accountingYear.table.header.endDate" }),
      dataIndex: "endDate",
      render: value => (value === "initial" ?
        <><VaporDatePicker
          getPopupContainer={(trigger) => trigger.parentNode}
          placeholder={intl.formatMessage({ id: "accountingYear.table.findDate"})}
          allowClear={true}
          className="date-search"
          onChange={(e) => e ? handleChange("endDate", moment(e).format(DATE_FORMAT_FOR_API)) : handleChange("endDate", null)}
        />
        </> : <span>{moment(value).format(DATE_FORMAT_FOR_DISPLAY)}</span>),
      sorter: (a, b) => { return a.endDate ==="initial" || b.endDate ==="initial" ? 0 : a.endDate.localeCompare(b.endDate);}
    },
    /* TODO al momento il dato non ci arriva ancora
    {
      title: intl.formatMessage({ id: "accountingYear.table.header.useful" }),
      dataIndex: "amount",
      // numeral(Math.abs(amount)).format("0,0.00")
      render: value => (value === "initial" ?
        <Input
          className="input-search transparent"
          allowClear={true}
          suffix={<FontAwesomeIcon
            icon={["far", "search"]}            
          />}          
          placeholder="Cerca"
          onChange={(e) => handleChange("amount", e.target.value)}
        />
        : numeral(Math.abs(value)).format("0,0.00") + "€"),
      sorter: (a, b) => { return a.amount ==="initial" || b.amount ==="initial" ? 0 :a.amount - b.amount;}
    },
    {
      title: "Perdita",
      dataIndex: "amount",
      // numeral(Math.abs(amount)).format("0,0.00")
      render: value => (value === "initial" ?
        <Input
          className="input-search transparent"
          allowClear={true}
          suffix={<FontAwesomeIcon
            icon={["far", "search"]}            
          />}          
          placeholder="Cerca"
          onChange={(e) => handleChange("amount", e.target.value)}
        />
        : numeral(Math.abs(value)).format("0,0.00") + "€"),
      sorter: (a, b) => { return a.amount ==="initial" || b.amount ==="initial" ? 0 :a.amount - b.amount;}
    },
    */
    {
      title: intl.formatMessage({ id: "accountingYear.table.header.closedOpened" }),
      dataIndex: "closed",
      render: value => (value === "initial" ?
        <Select
          getPopupContainer={(trigger) => trigger.parentNode}
          className="input-search transparent noBorder"
          allowClear={true}
          placeholder={<FormattedMessage id="accountingYear.table.all" />}
          onChange={(val) => handleChange("closed",val)}
        >
          <Option value=""><FormattedMessage id="accountingYear.table.all" /></Option>
          <Option value="false"><FormattedMessage id="accountingYear.table.open" /></Option>
          <Option value="true"><FormattedMessage id="accountingYear.table.close" /></Option>
        </Select>
        
        : 
        <span>
          <FontAwesomeIcon style={{paddingRight: "12px"}} icon={["far", value ? "folder": "folder-open"]} /> {value ? intl.formatMessage({id:"accountingYear.table.close"}) : intl.formatMessage({id:"accountingYear.table.open"})} </span>),
      sorter: (a, b) => { return a.closed ==="initial" || b.closed ==="initial" ? 0 : a.closed - b.closed;}
    },
    {
      title: "",
      dataIndex: "action",
      render: (value, record) => (value === "initial" ?
        null : <FontAwesomeIcon style={{color: "#0090d1", cursor: "pointer"}} 
          icon={["far", "external-link-square-alt"]} onClick={() => {            
            setDrawerAccountingPeriodId(record.id);
            setSelectedSequenceNumber(record.sequenceNumber);
            setStartDate(record.startDate);
            setEndDate(record.endDate);
          }
          } />)      
    }
  ];

  const initial = {
    key: "initial",
    closed: "initial",
    endDate: "initial",
    id: "initial",
    sequenceNumber: "initial",
    startDate: "initial",
    action: "initial",
    amount: "initial"
  };
  
  return ( 
    <>  
      <Table
        className="vaporTable" 
        columns={columns}
        dataSource={[initial, ...filteredList]}    
        pagination={false}      
      />
      {filteredList.length === 0 &&
      <EmptyState withIcon={true} 
        title={intl.formatMessage({ id: "accountingYear.table.empty.title" })}
        description={intl.formatMessage({ id: "accountingYear.table.empty.description" })}
      />
      }
              
      <DrawerOperationsList accountingPeriodId={drawerAccountingPeriodId}
        selectedSequenceNumber={selectedSequenceNumber}
        setDrawerAccountingPeriodId={setDrawerAccountingPeriodId}     
        startDate={startDate}
        endDate={endDate}    
      />
      
    </>
           
  );
};

export default AccountingYearsList;